module.exports = __webpack_public_path__ + "c3afa5bc47b2b9ef32a7e5277fbf9711.jpg";